import Reveal from "@/components/base/Reveal";

export default function Integration() {
  return (
    <section id="integration" className="scroll-mt-16 bg-white">
      <div className="mx-auto max-w-5xl px-4 py-24 text-center md:px-6 md:py-32">
        <Reveal delay={100}>
          <h2 className="mt-6 font-heading text-4xl font-extrabold leading-tight tracking-tight text-foreground-950 md:text-6xl">
            <span className="peach-gradient-text">HURMA</span> та{" "}
            <span className="green-gradient-text">OLX Робота</span>
            <br />
            прибирають зайві кроки
          </h2>
        </Reveal>

        <Reveal delay={200}>
          <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-foreground-600 md:text-xl">
            Інтеграція з OLX Робота передає відгуки одразу у вашу ATS-воронку. Рекрутер бачить 
            кандидата, вакансію, джерело й статус в єдиній системі — без таблиць, пересилань 
            і перенесення контактів.
          </p>
        </Reveal>

        <Reveal delay={300}>
          <div className="mt-20 flex items-center justify-center gap-6 md:mt-24 md:gap-12">
            <div className="flex flex-col items-center gap-4">
              <img
                src="https://storage.helloreaddy.io/project_files/0681f556-5fc1-4d4e-8f10-a3f4dfdc820d/aad5c07c-bdce-4578-8acb-5afa421f4f40_compressed_Frame-1000000996.webp"
                alt="OLX Робота"
                className="h-20 w-20 object-cover md:h-32 md:w-32"
              />
            </div>

            <div className="relative h-12 w-24 overflow-hidden md:h-16 md:w-48">
              {[0, 1, 2, 3].map((i) => (
                <i
                  key={i}
                  className="ri-file-text-line file-fly absolute left-0 top-1/2 text-3xl md:text-4xl"
                  style={{ animationDelay: `${i * 0.7}s` }}
                ></i>
              ))}
            </div>

            <div className="flex flex-col items-center gap-4">
              <img
                src="https://storage.helloreaddy.io/project_files/0681f556-5fc1-4d4e-8f10-a3f4dfdc820d/f9507219-1f71-4dd9-b509-27d9bc03018b_compressed_Frame-1000000997.webp"
                alt="HURMA"
                className="h-20 w-20 object-cover md:h-32 md:w-32"
              />
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}